import { render, staticRenderFns } from "./components.button-svg.vue?vue&type=template&id=33a2f260"
import script from "./components.button-svg.vue?vue&type=script&lang=js"
export * from "./components.button-svg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports